import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/notifications')({
  component: NotificationsLayout,
});

function NotificationsLayout() {
  return <Outlet />;
}
